

import React from 'react';
import { useTravelerStyles } from '../../../common/traveler/TravelerStyles';
import { Grid, Typography } from '@material-ui/core';

export const ReportTravelerGroup = ({ data }: any) => {
    const classes = useTravelerStyles();

    return (
        <>
            <Grid item xs={2} className={classes.baseBorder} style={{ backgroundColor: "yellow" }}>
                <Typography variant="body2" align="center" style={{ fontWeight: "bold" }}>
                    {data.execution_group_number}
                </Typography>
            </Grid>
            <Grid
                item
                xs={10}
                className={classes.baseBorder}
                style={{ backgroundColor: "#eeeeee" }}
            >
                <Typography
                    variant="body2"
                    align="center"
                    style={{ fontWeight: "bold" }}
                >
                    {data.execution_group_name}
                </Typography>
            </Grid>
            <Grid item xs={2} className={classes.baseBorder}>
                <Typography variant="body2" align="center">{data.report_definition_name}</Typography>
            </Grid>
            <Grid item xs={2} className={classes.baseBorder}>
                
                <Typography variant="body2" align="center">{data.execution_group_name ? data.execution_group_name : 'N/A'}</Typography>
            </Grid>
            <Grid item xs={2} className={classes.baseBorder}>
              
                <Typography variant="body2" align="center">{data.short_name ? data.short_name : 'N/A'}</Typography>
            </Grid>
            <Grid item xs={2} className={classes.baseBorder}>
                
                <Typography variant="body2" align="center">{data.disposition_name ? data.disposition_name : 'N/A'}</Typography>
            </Grid>
            <Grid item xs={2} className={classes.baseBorder}>

                <Typography variant="body2" align="center">{data.product_definition_name ? data.product_definition_name : 'N/A'}</Typography>
            </Grid>
            <Grid item xs={2} className={classes.baseBorder}>

                <Typography variant="body2" align="center">{data.name ? data.name : 'N/A'}</Typography>
            </Grid>
        </>
    );
};


